import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const OnClickOutside = ({ isActive, onClickOutside, className, onWheel, children }) => {
	const wrapperRef = useRef(null);

	const handleClickOutside = (e) => {
		if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
			onClickOutside(e);
		}
	};

	useEffect(() => {
		if (isActive) {
			document.addEventListener('mousedown', handleClickOutside);
		} else {
			document.removeEventListener('mousedown', handleClickOutside);
		}

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [isActive]);

	return (
		<div
			className={className}
			ref={wrapperRef}
			onWheel={onWheel}
		>
			{children}
		</div>
	);
};

OnClickOutside.defaultProps = {
	isActive: true,
};

OnClickOutside.propTypes = {
	onClickOutside: PropTypes.func.isRequired,
	className: PropTypes.string,
	onWheel: PropTypes.func,
	children: PropTypes.any,
	isActive: PropTypes.bool,
};

export default OnClickOutside;